import React, { useState } from "react";
import API_BASE_URL from "../../../apiConfig";
import { useNavigate } from "react-router-dom";

const PanVerification = () => {
	const navigate = useNavigate();
	const [formData, setFormData] = useState({
		panNumber: "",
	});

	const [serverError, setServerError] = useState("");
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [showResultModal, setShowResultModal] = useState(false);
	const [resultDetails, setResultDetails] = useState(null);
	const [loading, setLoading] = useState(false);
	const [errors, setErrors] = useState({ panNumber: "" });

	const handleChange = (e) => {
		const { name, value } = e.target;
		const upperValue = value.toUpperCase(); // PAN is always uppercase

		if (name === "panNumber") {
			let errorMsg = "";
			if (!upperValue) {
				errorMsg = "PAN Number is required.";
			} else if (upperValue.length !== 10) {
				errorMsg = "PAN Number must be 10 characters long.";
			} else if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(upperValue)) {
				errorMsg = "Enter valid PAN format (e.g., ABCDE1234F).";
			}
			setErrors((prev) => ({ ...prev, panNumber: errorMsg }));
			setFormData((prev) => ({ ...prev, [name]: upperValue }));
			return;
		}

		setFormData((prev) => ({ ...prev, [name]: upperValue }));
	};

	const handleStay = () => {
		setShowConfirmModal(false);
	};

	const handleFormSubmit = (e) => {
		e.preventDefault();
		setServerError("");

		// Final validation before showing modal
		if (errors.panNumber || !formData.panNumber || formData.panNumber.length !== 10) {
			setServerError("Please enter a valid 10-character PAN Number.");
			return;
		}

		setShowConfirmModal(true);
	};

	const handleConfirm = async () => {
		setShowConfirmModal(false);

		const panVerificationDto = {
			PanNumber: formData.panNumber,
		};
		const authToken = localStorage.getItem("authToken");

		setLoading(true);
		try {
			const url = `${API_BASE_URL}/PanVerification/Verify`;

			const response = await fetch(url, {
				method: "POST",
				headers: {
					Authorization: `Bearer ${authToken}`,
					"Content-Type": "application/json",
				},
				body: JSON.stringify(panVerificationDto),
			});

			const data = await response.json();

			if (response.ok) {
				window.dispatchEvent(new Event("balanceUpdated"));
				
				setResultDetails({
					success: data.success,
					message: data.message,
					data: data.data // will have pan_no, registered_name, father_name, pan_type on success
				});
				setShowResultModal(true);
			} else {
				setResultDetails({
					success: false,
					message: data.message || "PAN verification failed.",
					data: null
				});
				setShowResultModal(true);
			}
		} catch (err) {
			setServerError(err.message);
			setResultDetails({
				success: false,
				message: "An error occurred while connecting to the server.",
				data: null
			});
			setShowResultModal(true);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="kids-avenue-font">
			<form onSubmit={handleFormSubmit}>
				<div className="card card-default">
					<div className="card-body">
						<div className="row">
							<div className="form-group col-md-4">
								<label htmlFor="panNumber">PAN Number <span style={{ color: "red" }}>*</span></label>
								<input
									type="text"
									className="form-control"
									id="PanNumber"
									name="panNumber"
									value={formData.panNumber}
									onChange={handleChange}
									maxLength={10}
									placeholder="e.g. ABCDE1234F"
								/>
								{errors.panNumber && <small style={{ color: "red" }}>{errors.panNumber}</small>}
							</div>
						</div>
						<div className="form-footer pt-4 text-center">
							<p>Note: Form Submission Charges ₹4</p>
							<button 
								type="submit" 
								className="btn btn-primary btn-pill"
								disabled={loading}
							>
								{loading ? (
									<>
										<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: "1rem", height: "1rem", marginRight: "8px" }}></span>
										Verifying PAN...
									</>
								) : (
									"Verify PAN"
								)}
							</button>
						</div>
					</div>
				</div>

				{serverError && <div className="alert alert-danger">{serverError}</div>}
			</form>
			
			{showConfirmModal && (
				<div className="modal-backdrop" style={{
					position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
					background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
				}}>
					<div style={{
						background: "#fff", padding: 24, borderRadius: 10, minWidth: 320, textAlign: "center", boxShadow: "0 5px 20px rgba(0,0,0,0.2)"
					}}>
						<h5 style={{ color: "#9e6de0", fontWeight: "bold", marginBottom: 12 }}>Confirm Submission</h5>
						<p style={{ color: "#455a64" }}>Do you want to submit this PAN verification request? Charges: ₹4</p>
						<div style={{ marginTop: 20 }}>
							<button className="btn btn-secondary mr-2 btn-pill" type="button" onClick={handleStay}>Stay</button>
							<button className="btn btn-primary btn-pill" type="button" style={{ backgroundColor: "#9e6de0", borderColor: "#9e6de0" }} onClick={handleConfirm}>Confirm</button>
						</div>
					</div>
				</div>
			)}

			{showResultModal && resultDetails && (
				<div className="modal-backdrop" style={{
					position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
					background: "rgba(0,0,0,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 9999
				}}>
					<div style={{
						background: "#fff", borderRadius: 12, width: "90%", maxWidth: 420, overflow: "hidden", boxShadow: "0 10px 30px rgba(0,0,0,0.25)"
					}}>
						{/* Modal Header using Brand Purple */}
						<div style={{
							background: resultDetails.success ? "linear-gradient(135deg, #9e6de0 0%, #8243d7 100%)" : "linear-gradient(135deg, #dc3545 0%, #bd2130 100%)",
							padding: "18px 20px", color: "#fff", textAlign: "center"
						}}>
							<h5 style={{ color: "#fff", margin: 0, fontWeight: "bold", fontSize: "1.2rem" }}>
								{resultDetails.success ? "PAN Verified Successfully" : "PAN Verification Failed"}
							</h5>
						</div>

						<div style={{ padding: 24, textAlign: "center" }}>
							{resultDetails.success && resultDetails.data ? (
								<>
									<div style={{ textAlign: "left", background: "#f8f9fa", padding: 16, borderRadius: 8, border: "1px solid #e9ecef", marginBottom: 20 }}>
										<div style={{ margin: "6px 0 16px 0", textAlign: "center" }}>
											<strong style={{ color: "#212529" }}>Verified PAN Number</strong> 
											<div style={{
												marginTop: 6,
												background: "#e8f5e9",
												color: "#2e7d32",
												padding: "10px 14px",
												borderRadius: 6,
												fontWeight: "bold",
												fontSize: "1.35rem",
												letterSpacing: "2px",
												border: "1px solid #a5d6a7"
											}}>
												{resultDetails.data.pan_no || formData.panNumber}
											</div>
										</div>
										<p style={{ margin: "8px 0", color: "#495057" }}><strong>Registered Name:</strong> {resultDetails.data.registered_name}</p>
										<p style={{ margin: "8px 0", color: "#495057" }}><strong>Father Name:</strong> {resultDetails.data.father_name}</p>
										<p style={{ margin: "8px 0", color: "#495057" }}><strong>PAN Type:</strong> {resultDetails.data.pan_type}</p>
									</div>
									<p style={{ fontSize: "88%", color: "#6c757d", marginBottom: 20 }}>₹4 has been deducted from your wallet balance.</p>
									<button className="btn btn-primary btn-block btn-pill" type="button" style={{ backgroundColor: "#9e6de0", borderColor: "#9e6de0" }} onClick={() => {
										setShowResultModal(false);
										setFormData({ panNumber: "" });
									}}>Verify Another PAN</button>
								</>
							) : (
								<>
									<div style={{ textAlign: "left", background: "#fff5f5", border: "1px solid #ffcdd2", padding: 16, borderRadius: 8, marginBottom: 20, color: "#721c24" }}>
										<p style={{ margin: "6px 0" }}><strong>Entered PAN:</strong> {formData.panNumber}</p>
										<p style={{ margin: "10px 0 0 0", borderTop: "1px solid #ffcdd2", paddingTop: 10, color: "#c62828" }}>
											<strong>Reason:</strong> {resultDetails.message}
										</p>
									</div>
									<p style={{ fontSize: "88%", color: "#6c757d", marginBottom: 20 }}>No money was deducted for this failed attempt.</p>
									<button className="btn btn-primary btn-block btn-pill" type="button" style={{ backgroundColor: "#9e6de0", borderColor: "#9e6de0" }} onClick={() => {
										setShowResultModal(false);
									}}>Try Again</button>
								</>
							)}
						</div>
					</div>
				</div>
			)}
		</div>
	);
};

export default PanVerification;
